import FileBrowser from "../../../services/api/file-browser";
import {FILE_TYPE, SOURCE, TYPE} from "../../../constants/file-image-types";
import {FILE_BROWSER_FILTER_QUERY_KEYS, TAB_SOURCE_MAP, TABS} from "./constants";
import Requests from "../../../services/api/file-browser";

const resolvePoint = (route) => {
    const tab = route.params.tab;
    const path = route.params.pathMatch;
    const fileId = route.query.fileId;

    const mainSource = TAB_SOURCE_MAP[tab];
    if (tab !== TABS.FILES || !path || tab === TABS.PRODUCTS) {
        if (fileId) {
          return SOURCE.FOLDER_CONTENT_RESOLVE_POINT
        }
      
        return mainSource;
    }

    const lastFolder = path.split('/').pop()

    const folder = Number(lastFolder);

    if (isNaN(folder)) {
        return mainSource;
    }

    return `${SOURCE.FOLDER_CONTENT_RESOLVE_POINT}&folderId=${lastFolder}`
}
const pageNumberParam = (route) => {
    return `&pageNumber=${route.query.page}`
}
const typeParam = (route) => {
    return route.query.type ? `&type=${route.query.type}` : '';
}
const searchQueryParam = route => {
    if (route.params.tab === TABS.BYNDER_ASSETS) {
        const searchTerm = route.query.searchTerm || '';
        const searchType = route.query.searchType || 'search';
        return `&searchTerm=${searchTerm}&searchType=${searchType}`;
    } else {
        return `&searchKey=${route.query.search || ''}`;
    }
}
const sortParam = route => {
    return route.query.sort_field ? `&sort_field=${route.query.sort_field}&sort=${route.query.sort ?? 'asc'}` : '';
}
const filterQueryParam = route => {
    return FILE_BROWSER_FILTER_QUERY_KEYS
        .filter(key => route.query[key] !== undefined && route.query[key] !== '')
        .map(key => `&${key}=${encodeURIComponent(route.query[key])}`)
        .join('');
}
const fileIdParam = route => {
  return route.query.fileId ? `&fileId=${route.query.fileId}` : '';
}
const isLightWeightParam = route => {
  return route.query.isLightWeight ? `&isLightWeight=true` : '';
}
const SOURCE_BUILDERS = [
    resolvePoint,
    searchQueryParam,
    pageNumberParam,
    typeParam,
    sortParam,
    filterQueryParam,
    fileIdParam,
    isLightWeightParam,
]
export const resolveSource = (route) => {
    return SOURCE_BUILDERS.reduce((url, resolve) => `${url}${resolve(route)}`, '')
}
export const resolveMultipleDeleteMethod = (tab) => {
    switch (tab) {
        case TABS.PRODUCTS:
            return FileBrowser.deleteMultipleProductFile
        case TABS.STOCK_IMAGES:
            return FileBrowser.deleteMultipleStockImages
        case TABS.BACKGROUND:
          return FileBrowser.deleteMultipleBackgroundImages
        case TABS.FILES:
            return FileBrowser.deleteMultipleFolderFile
        case TABS.BYNDER_ASSETS:
            return FileBrowser.deleteBynderAssets;
        case TABS.SALSIFY_ASSETS:
            return FileBrowser.deleteSalsifyAssets;
        default:
            throw new Error('no handler for this tab')
    }
}
export const resolveDownloadMethod = (route, items) => {
  const tab = route.params.tab

  switch (tab) {
    case TABS.BACKGROUND:
    case TABS.STOCK_IMAGES: {
      return FileBrowser.download
    }
    case TABS.PRODUCTS: {
      const [firstItem] = items
      if (firstItem.type === FILE_TYPE.FOLDER) {
        return FileBrowser.downloadProductFolder;
      } else {
        return FileBrowser.download;
      }
    }
    case TABS.FILES: {
      const [firstItem] = items
      if (firstItem.type === FILE_TYPE.FOLDER) {
        return FileBrowser.downloadFolder;
      } else {
        return FileBrowser.downloadFolderFiles;
      }
    }
    case TABS.BYNDER_ASSETS:
      return FileBrowser.downloadBynderAssets;
    case TABS.SALSIFY_ASSETS:
      return FileBrowser.downloadSalsifyAssets;
    default:
      throw new Error('no handler for this case')
  }
}

export const resolveDeleteItemMethod = (tab, item) => {
    switch (tab) {
        case TABS.PRODUCTS:
            switch (item.type) {
                case TYPE.FOLDER:
                    return Requests.deleteProductFolder;
                default:
                    return FileBrowser.deleteMultipleProductFile
        }
        case TABS.FILES:
            switch (item.type) {
                case TYPE.FOLDER:
                    return Requests.deleteFolder;
                default:
                    return Requests.deleteFolderFile;
            }
        case TABS.STOCK_IMAGES:
            return Requests.deleteStockFile;
        default:
            return () => Promise.reject();
    }
}
